type MicroAgentLike = {
  noticeError: (error: unknown, attributes?: Record<string, unknown>) => void
}

const createNewRelicAgent = (): MicroAgentLike => ({
  noticeError: console.error
})

const microAgent = createNewRelicAgent()

export default microAgent
